import { Dispatch, FC, ReactNode, SetStateAction } from "react";
import {
  Flex,
  IconButton,
  Input,
  InputGroup,
  InputRightAddon,
} from "@chakra-ui/react";
import { handleEnterOnSearch } from "../../../utils/constants";
import { SearchIcon } from "@chakra-ui/icons";
import { borderColor, primaryColor } from "../../../utils/colors";
import { CiEraser } from "react-icons/ci";

interface SearchAreaProps {
  handleSearchCall: () => void;
  handleRemoveCall?: () => void;
  setInputSearch: Dispatch<SetStateAction<string>>;
  inputSearch: string;
  children?: ReactNode;
  placeholderText?: string;
  hasIcon?: boolean;
  isDisabled?: boolean;
  fieldNameObject?: string;
  register?: any;
  hasInputSearch?: boolean;
}

const SearchArea: FC<SearchAreaProps> = ({
  handleSearchCall,
  handleRemoveCall,
  setInputSearch,
  inputSearch,
  children,
  placeholderText = "Pesquisar",
  hasIcon = false,
  isDisabled = false,
  hasInputSearch = true,
}) => {
  return (
    <Flex direction="column" gap={4}>
      {hasInputSearch && (
        <InputGroup>
          <Input
            placeholder={placeholderText}
            sx={{
              "&::placeholder": {
                fontSize: "md",
                color: "gray.400",
              },
              borderRightRadius: "0",
            }}
            value={inputSearch}
            onChange={(e) => {
              setInputSearch(e.target.value);
            }}
            onKeyDown={(e) => {
              handleEnterOnSearch(e, handleSearchCall);
            }}
            isDisabled={isDisabled}
          />
          {hasIcon && (
            <>
              <InputRightAddon p={0} borderRadius="0">
                <IconButton
                  aria-label="Limpar"
                  variant="solid"
                  icon={<CiEraser size="22px" />}
                  color={primaryColor}
                  borderY="1px solid"
                  borderX="0"
                  borderColor={borderColor}
                  onClick={handleRemoveCall}
                  isDisabled={isDisabled}
                  borderRadius="0"
                />
              </InputRightAddon>
              <InputRightAddon p={0}>
                <IconButton
                  aria-label="Pesquisar"
                  variant="solid"
                  icon={<SearchIcon />}
                  color={primaryColor}
                  borderY="1px solid"
                  borderX="0"
                  borderColor={borderColor}
                  onClick={handleSearchCall}
                  isDisabled={isDisabled}
                  borderLeftRadius="0"
                />
              </InputRightAddon>
            </>
          )}
        </InputGroup>
      )}
      {children}
    </Flex>
  );
};

export default SearchArea;
